import { useModalAction } from '@components/common/modal/modal.context'
import { useState } from 'react'
import Image from '@components/ui/image'
import { DELIVERY, PICK_UP } from '@constants/index'
import OutlineButton from '@components/ui/outline-button'

const addtoCartoptions = [
  {
    id: 1,
    path: '/',
    image: '/assets/images/clickcollect/delivery.svg',
    name: 'delivery',
    width: 50,
    height: 50,
  },
  {
    id: 2,
    path: '/',
    image: '/assets/images/clickcollect/pickup.svg',
    name: 'pickup',
    width: 50,
    height: 60,
  },
  {
    id: 3,
    path: '/',
    image: '/assets/images/clickcollect/subscribe.svg',
    name: 'subscribe',
    width: 50,
    height: 60,
  },
]

export default function ProductClickCollect({
  kingstonClicked,
  setKingstonClicked,
}: any) {
  const [subscribeClicked, setSubscribeClicked] = useState(false)
  const [selectedOption, setSelectedOption] = useState<string | null>(DELIVERY)
  const { openModal } = useModalAction()
  const onClick = (optionClicked: string) => {
    setSelectedOption(optionClicked)
    if (optionClicked === DELIVERY) {
      setKingstonClicked(false)
      // setSubscribeClicked(false)
    }
    if (optionClicked === PICK_UP) {
      setKingstonClicked(true)
      // setSubscribeClicked(false)
    }
    if (optionClicked === 'subscribe') {
      setKingstonClicked(false)
      // setSubscribeClicked(true)
    }
  }

  return (
    <div>
      <OutlineButton
        className="w-[140px] h-[60px] mt-3"
        disabled={kingstonClicked}
        isSelected={selectedOption === DELIVERY}
        onClick={() => onClick('delivery')}
      >
        <div className="flex justify-center h-[30px]">
          <Image
            src={addtoCartoptions[0].image}
            alt={addtoCartoptions[0].name}
            height={addtoCartoptions[0].height}
            width={addtoCartoptions[0].width}
            style={{ width: 'auto' }}
          />
        </div>
        Delivery
      </OutlineButton>
      <OutlineButton
        className="w-[140px] h-[60px] mt-3"
        disabled={!kingstonClicked}
        isSelected={selectedOption === PICK_UP}
        onClick={() => onClick('pickup')}
      >
        <div className="flex justify-center h-[30px]">
          <Image
            src={addtoCartoptions[1].image}
            alt={addtoCartoptions[1].name}
            height={addtoCartoptions[1].height}
            width={addtoCartoptions[1].width}
            style={{ width: 'auto' }}
          />
        </div>
        Pick up
      </OutlineButton>
      {/* <OutlineButton
        className="w-[140px] h-[60px] mt-3 whitespace-nowrap "
        disabled={!subscribeClicked}
        onClick={() => onClick('subscribe')}
      >
        <div className="flex justify-center h-[30px]">
          <Image
            src={addtoCartoptions[2].image}
            alt={addtoCartoptions[2].name}
            height={addtoCartoptions[2].height}
            width={addtoCartoptions[2].width}
            style={{ width: 'auto' }}
          />
        </div>
        Subscribe 2 save
      </OutlineButton> */}
      {kingstonClicked && (
        <>
          <p className="text-brand-dark text-sm mt-4 font-semibold">
            Available in Kingston, ON store
          </p>
          <span
            onClick={() => openModal('CLICKCOLLECT_POPUP')}
            className="text-brand-dark text-sm hover:underline cursor-pointer text-brand-dodgerBlue"
          >
            Learn How Pickup Works
          </span>
        </>
      )}
      {subscribeClicked && (
        <p className="text-brand-dark text-sm mt-4 font-semibold">
          Subscribe 2 Save __% off this item on repeat orders.
        </p>
      )}
    </div>
  )
}
